<template>
  <b-modal
    :id="id"
    title="Game Over"
    ok-title="New Game"
    content-class="finish-modal"
    header-bg-variant="dark"
    header-text-variant="light"
    header-border-variant="dark"
    body-bg-variant="dark"
    body-text-variant="light"
    footer-bg-variant="dark"
    footer-border-variant="dark"
    ok-variant="secondary"
    ok-only
    scrollable
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    @ok="newGame"
  >
    <div class="scores">
      <b-row>
        <b-col class="score-label">Total Score</b-col>
        <b-col class="score-number">{{totalScore}}</b-col>
      </b-row>
      <b-row>
        <b-col class="score-label">Percentage</b-col>
        <b-col class="score-number">{{totalScorePercentage}}%</b-col>
      </b-row>
    </div>
    <b-table
      :items="roundsTableItems"
      :fields="roundsTableFields"
      class="score-table"
    >
      <template v-slot:head(timesZoomedOut)="data">
        <b-img :src="zoomIcon" alt="Times zoomed out" class="header-icon" />
      </template>
    </b-table>
  </b-modal>
</template>

<script>
import { BCol, BImg, BModal, BRow, BTable } from 'bootstrap-vue'
import zoomIcon from '../../img/whence/zoom-icon.png'
import { Round } from '../../libs/whence/round.js'

export default {
  props: {
    id: {
      type: String,
      required: true
    },
    rounds: {
      type: Array,
      required: true
    }
  },
  data: function() {
    return {
      roundsTableFields: [
        {
          key: 'locationName',
          label: 'Locations'
        },
        {
          key: 'distance',
          label: '',
          class: 'distance-cell'
        },
        {
          key: 'timesZoomedOut'
        },
        {
          key: 'points',
          label: '%'
        }
      ],
      zoomIcon: zoomIcon
    };
  },
  computed: {
    roundsTableItems() {
      return this.rounds.map((round) => ({
        locationName: round.locationName,
        distance: round.isSkipped ? 'skipped' : round.guessedDistanceString(),
        timesZoomedOut: round.isSkipped ? '' : round.timesZoomedOut(),
        points: round.isSkipped ? '' : round.points
      }));
    },
    totalScore() {
      return Round.totalPoints(this.rounds);
    },
    totalScorePercentage() {
      return Math.round(Round.totalPointsPercentage(this.rounds));
    }
  },
  methods: {
    newGame(evt) {
      this.$emit('new-game');
    }
  },
  components: {
    'b-col': BCol,
    'b-img': BImg,
    'b-modal': BModal,
    'b-row': BRow,
    'b-table': BTable
  }
}
</script>

<style>
.finish-modal {
  border: 2px white solid;
}
.finish-modal button {
  color: #fdcd25;
  font-weight: bold;
}
.scores .col {
  font-size: 1.8rem;
}
.scores .score-number {
  font-weight: bold;
  color: #fdcd25;
}
.score-table {
  margin-top: 2rem;
  color: white;
}
.score-table th {
  color: #fdcd25;
}
.score-table .header-icon {
  width: 1.3rem;
}
.score-table .distance-cell {
  white-space: nowrap;
}
</style>
